import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GTM } from 'src/app/services/gtm.service';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'ng-hbm-bdi-banner',
  templateUrl: './banner.component.html'
})
export class BannerComponent implements OnInit {

  customerName: string;
  customerMagentoId: string;

  constructor(private customer: UserService, private modalService: ModalService, private router: Router, private gtm: GTM) { }

  ngOnInit(): void { }

  isLoggedToClient(): boolean {
    if (this.customer.userDatas) {
      return this.customer.userDatas.otherAccount;
    }
    return false;
  }

  isHomeComponent(): boolean {
    return this.router.url === "/";
  }

  goToHomePage() {    
    if (this.customer.initContext) {
      this.customer.context = this.customer.initContext;
    }
    this.router.navigate(['/']);
  }

  getCustomerName(): string {
    if (this.isLoggedToClient()) {
      return this.customer.userDatas.otherAccount.completeName;
    }
  }

  getMagentoId(): string {
    if (this.isLoggedToClient()) {
      return this.customer.userDatas.otherAccount.magentoId;
    }
  }

  openProjects() {
    this.modalService.display(
      MODAL.PROJECTS,
      { customerId: this.customer.userDatas.otherAccount.hbmId });
  }

  logout() {
    this.gtm.trackEvent('click', 'banner', 'close-session');
    this.customer.userDatas.otherAccount = null;
    this.customer.byMeServiceRef.byMeApiToken = null;
    if (this.customer.initContext) {
      this.customer.context = this.customer.initContext;
    }
    this.router.navigate(['/']);
  }
}
